<template>
    <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
        <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
            <div class="container" v-bind:style="ContainerPadding">
                <!-- Heading -->
                <div class="w-lg-65 text-center mx-lg-auto">
                    <omnieditor :iseditmode="iseditmode" editortype="tinymce" :init="EditorConfig" keyDown v-model="BlockProps.Header" tag-name="h2" class="text-center">
                    </omnieditor>
                    <omnieditor :iseditmode="iseditmode" editortype="tinymce" :init="EditorConfig" keyDown v-model="BlockProps.Subtext" tag-name="p" class="text-center">
                    </omnieditor>
                </div>
                <!-- End Heading -->

                <div class="w-lg-65 mx-lg-auto">
                    <div class="row row-cols-2 row-cols-sm-4 justify-content-center">
                        <div class="col mb-5 mb-sm-0" v-for="nugget in BlockProps.Nuggets">
                            <!-- Icon Block -->
                            <div class="text-center">
                                <div class="mb-3">
                                    <propertyiconeditor :blockprops="BlockProps" :inline="true" v-model:icon="nugget.Icon" :prompt="'Icon (click to change)'"></propertyiconeditor>
                                </div>
                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" :init="EditorConfig" keyDown v-model="nugget.Content" tag-name="h5" class="text-center">
                                </omnieditor>
                            </div>
                            <!-- End Icon Block -->
                        </div>
                        <!-- End Col -->

                    </div>
                    <!-- End Row -->
                </div>


                <!-- End Row -->
            </div>






        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>


                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    export default {
        inheritAttrs: false,
        name: 'SimpleRowNuggets2',
        mixins: [ContentBlockBase],
        props: [],
        components: {
        },
        computed:
        {
           
        },
        data() {
            return {  
         
            };
        },
        methods:
        {
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
        },

        setup(props, context)
        {             
            return {} 
        },
        created()
        {           
        },
        beforeUnmount()
        {
        },
        mounted() {
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
</style>

